<app-modal-header-common [title]="name" [dialogRef]="dialogRef">
</app-modal-header-common>
<div style="padding: 20px; font-size: 13px">
  <div>
    <span>Description: </span>
    <b>{{ description }}</b>
  </div>
  <div>
    <span>Category: </span>
    <b>{{ category }}</b>
  </div>
  <div>
    <span>Applicability: </span>
    <b>{{ applicability }}</b>
  </div>
  <app-tag *ngIf="showTags" [tagsIds]="tagsList" [isReadOnly]="true"></app-tag>
  <hr class="my-2" />

  <div *ngIf="template" style="height: 60vh; overflow: scroll">
    <mat-accordion>
      <mat-expansion-panel
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
        [expanded]="isFirst"
        *ngFor="let domain of questions; first as isFirst"
      >
        <mat-expansion-panel-header>
          <mat-panel-title> {{ domain.domain }} </mat-panel-title>
        </mat-expansion-panel-header>

        <!-- Sub-Accordion for Subdomains -->
        <div style="padding: 10px !important">
          <mat-accordion>
            <mat-expansion-panel *ngFor="let subdomain of domain.subdomains">
              <mat-expansion-panel-header>
                <mat-panel-title> {{ subdomain.sub_domain }} </mat-panel-title>
              </mat-expansion-panel-header>
              <div
                *ngFor="let data of subdomain.questions; let i = index"
                class="requirement-card"
              >
                <div class="requirement-header">
                  <div class="requirement-number">
                    {{ i + 1 }}
                  </div>

                  <div class="requirement-content">
                    <div class="requirement-title">
                      {{ data.requirement }}
                    </div>

                    <div class="requirement-meta">
                      <mat-chip-list>
                        <mat-chip selected>
                          {{ data.checklist_items?.length || 0 }}
                          Checklist Item{{
                            (data.checklist_items?.length || 0) !== 1 ? "s" : ""
                          }}
                        </mat-chip>

                        <mat-chip selected>
                          {{ getDocumentCount(data) }}
                          Document{{ getDocumentCount(data) !== 1 ? "s" : "" }}
                        </mat-chip>
                      </mat-chip-list>
                    </div>
                  </div>

                  <button
                    *ngIf="data.checklist_items.length"
                    mat-stroked-button
                    color="primary"
                    (click)="openChecklistDialog(data)"
                  >
                    View Checklist
                  </button>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <div
    style="padding: 10px; display: flex; justify-content: right"
    class="gap-2"
  >
    <button
      (click)="closeDialog()"
      mat-button
      mat-dialog-close
      color="primary"
      class="mx-1"
    >
      Close
    </button>
    <button
      *ngIf="auditOwner"
      mat-flat-button
      color="primary"
      (click)="closeModal(true)"
      style="width: auto"
    >
      Proceed
    </button>
  </div>
</div>

<ng-template #checklistPopup>
  <div class="modal-dialog m-0" style="max-width: 100%">
    <div class="modal-content" style="border: none">
      <app-modal-header-common
        title="Checklist Items"
        [dialogRef]="checklistDialogRef"
      >
      </app-modal-header-common>

      <div
        class="modal-body p-3"
        style="max-height: 60vh; overflow-y: auto; min-width: 650px"
      >
        <div *ngFor="let item of selectedChecklistItems" class="checklist-card">
          <div class="checklist-title">
            <mat-icon>check_circle</mat-icon>
            {{ item.name }}
          </div>

          <div
            *ngIf="item.required_documents?.length"
            class="documents-section"
          >
            <div class="documents-title">Required Documents</div>

            <div
              *ngFor="let doc of item.required_documents"
              class="document-row"
            >
              <mat-icon>description</mat-icon>
              {{ doc }}
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button mat-button color="primary" (click)="checklistDialogRef.close()">
          Close
        </button>
      </div>
    </div>
  </div>
</ng-template>
